

export const INIT_ROUTE = '/init-active'

export const OLD_RACES = '/init'

export const RACES = '/races'

export const SEARCH = '/players?search='